
<!-- Spinner -->
<app-page-spinner class="pt-4" [inline]="false" [busy]="busy"></app-page-spinner>

<div class="box-file-picker">
	<div class="box-container" style="height:600px"></div>
</div>